// ExactAddressModal.jsx
import React, { useState, useEffect } from 'react'

export default function ExactAddressModal({ onClose, onSelect }) {
  const [input, setInput] = useState('')
  const [suggestions, setSuggestions] = useState([])

  useEffect(() => {
    if (input.length < 3 || !window.google?.maps?.places) {
      setSuggestions([])
      return
    }
    new window.google.maps.places.AutocompleteService().getPlacePredictions(
      { input, componentRestrictions: { country: 'us' } },
      (preds, status) => {
        setSuggestions(status === 'OK' ? preds.map(p => p.description) : [])
      }
    )
  }, [input])

  return (
    <div
      style={{
        position: 'fixed', top: 0, left: 0,
        width: '100vw', height: '100vh',
        background: 'rgba(0,0,0,0.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000
      }}
      onClick={e => e.target === e.currentTarget && onClose()}
    >
      <div style={{
        background: '#fff',
        borderRadius: 12,
        padding: 24,
        width: 420,
        maxHeight: '80vh',
        overflowY: 'auto',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
        fontFamily: 'Arial, sans-serif'
      }}>
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          placeholder="Enter an address"
          style={{
            width: '100%',
            padding: '12px 16px',
            fontSize: 16,
            border: '1px solid #ddd',
            borderRadius: 8,
            outline: 'none',
            boxSizing: 'border-box',
            marginBottom: 12,
            transition: 'border-color 0.2s'
          }}
          onFocus={e => e.target.style.borderColor = '#0074e4'}
          onBlur={e => e.target.style.borderColor = '#ddd'}
        />

        <ul style={{
          listStyle: 'none',
          padding: 0,
          margin: 0,
          maxHeight: 300,
          overflowY: 'auto'
        }}>
          {suggestions.map(addr => (
            <li
              key={addr}
              onClick={() => onSelect(addr)}
              style={{
                padding: '10px 12px',
                cursor: 'pointer',
                borderBottom: '1px solid #f0f0f0',
                transition: 'background 0.2s'
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#f5faff'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              {addr}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
